import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        padding: '10px 20px',
        background: '#7B549E',
        borderRadius: 5,
        boxShadow: '0px 1px 4px 0px rgba(133, 133, 133, 0.25)',
        cursor: 'pointer'
    },
    text: {
        color: "#0D183F",
        fontFamily: "Figtree, sans-serif",
        fontSize: 14,
        fontWeight: 400,
        color: '#FFFFFF',
        userSelect: 'none'
    }
}))
const ButtonConfirm = ({
    handleClick
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root} onClick={handleClick}>
            <span className={classes.text}>Подтвердить</span>
        </div>
    )
}

export default ButtonConfirm;